import mutations from './mutations'
import actions from './actions'

const state = {
  all_gates: [],
  gates: [],
  gate: [],
  deleted_gates: [], 
  all_entry_modes: [],
  unticketed_vehicles: []
  
}

export default {
  state, mutations, actions
}
